<script setup>
import MarketingBlock from "~/components/organisms/MarketingBlock.vue";
import {useRoute} from "vue-router";

const props = defineProps({
  data: {
    type: Object,
  }
})

const route = useRoute();
</script>

<template>
  <MarketingBlock v-if="parseInt(route?.query?.page ?? 1) < 2" :no-counter="true" :banners="props.data.banners"/>
</template>
